/**
 * @typedef {import('../MapLibreMap.js').MLD} MLD
 */

window.OSM = window.OSM ?? {};
OSM.OSMTest = class OSMTest {

    /** @type {OSM.MapLibreMap} */
    map;


    /** @type {IMarkerProps|null} */
    primaryMarkerProps = null;

    /** @type {IMarkerProps|null} */
    userMarkerProps = null;

    /** @type {IMarkersProps|null} */
    clusterMarkerProps = null;

    /** @type {string|null} */
    testMarkerID = null;
    /** @type {string|null} */
    testObjectID = null;

    /**
     *
     * @param {HTMLElement} mapLibreTest
     */
    constructor(mapLibreTest) {
        /** @type {HTMLElement} */
        const osmMap = mapLibreTest.querySelectorAll('.osm-map')[0] ?? null;

        if(!osmMap){
            return;
        }

        const configID = osmMap.dataset.config_id
        /** @type {IMapProps} */
        let config = configID ? (OSM.MapConfigs[configID] ?? null) : null;
        config = config ?? OSM.MapConfigs.default;
        config = config ?? {};

        /** @type {IMapProps} */
        const props = OSM.deepCopyObjects(config);

        let mapID = osmMap.id;
        if(!mapID){
            const prefix = "mapLibreMap"
            let mapNumber = 1;
            mapID = prefix + mapNumber;
            while(document.querySelectorAll(mapID).length){
                mapNumber ++;
                mapID = prefix + mapNumber;
            }
            osmMap.id = mapID;
        }

        this.applyTestProps(props)

        new OSM.MapLibreMap(mapID, props);
        this.map = OSM.Maps[mapID];

        this.onReset = this.onReset.bind(this);
        this.onTest = this.onTest.bind(this);

        /** @type {HTMLButtonElement} */
        const resetBtn = mapLibreTest.querySelectorAll('.map-reset')[0] ?? null;
        /** @type {HTMLButtonElement} */
        const testBtn = mapLibreTest.querySelectorAll('.map-test')[0] ?? null;
        if(resetBtn){
            resetBtn.style.cursor = 'pointer';
            resetBtn.onclick = this.onReset;
        }
        if(testBtn){
            testBtn.style.cursor = 'pointer';
            testBtn.onclick = this.onTest;
        }
    }

    /**
     *
     * @param props {IMapProps}
     */
    applyTestProps(props){

        props.mapOptions = {
            container: "",
            zoom: 6
        }

        this.primaryMarkerProps = this.createPrimaryMarkerProps(props.primaryMarker);

        props.primaryMarker = this.primaryMarkerProps
        this.userMarkerProps = this.createUserMarkerProps(props.userMarker);
        props.userMarker = this.userMarkerProps

       // props.countryCode = "fr";
        //props.preferredMapFocusOrder = ["country"];

        this.clusterMarkerProps = this.createClusterMarkerProps();
        props.cluster = this.createClusterProps({
            ...props.cluster,
            markers: this.clusterMarkerProps,
        })
    }


    /**
     *
     * @param props {IMarkerProps=}
     * @returns {IMarkerProps}
     */
    createPrimaryMarkerProps (props) {
        props = props ?? {};
        /** @type {MLD._LngLat} */
        const lngLat = new maplibregl.LngLat(-6.6451433, 54.5761141);
        return {
            ...props,
            lngLat: lngLat,
            popupContent: props.popupContent ?? "Primary Marker",
            markerOptions:props.markerOptions ?? {
                draggable:true,
            }
        }
    }


    /**
     *
     * @param props {IBasicMarkerProps=}
     * @returns {IBasicMarkerProps}
     */
    createUserMarkerProps (props) {
        props = props ?? {};
        return {
            ...props,
            popupContent: props.popupContent ?? "Your Location"
        }
    }


    /**
     *
     * @param props {IMapClusterProps=}
     * @returns {IMapClusterProps}
     */
    createClusterProps (props) {
        props = props ?? {};
        return {
            ...props,
        //    clusterIcon: props.clusterIcon ?? {},
           // withUser: props.withUser ?? true,
         //   withPrimaryMarker: props.withPrimaryMarker ?? true
        }
    }

    /**
     *
     * @returns {IMarkersProps}
     */
    createClusterMarkerProps () {

        const minLat = 54.1365031;
        const maxLat = 55.4272952;
        const minLng = -8.1616571;
        const maxLng = -5.6090288;

        const amtLocateMarkers = 50;

        const multiplier = 10000000;
        /** @type {IMarkersProps} */
        const markersProps = {};
        for(let i = 0; i < amtLocateMarkers; i++) {
            /** @type {string[]} */
            const objectIDs = [];
            if(i === 999){
                objectIDs.push("object_"+i+"a");
                objectIDs.push("object_"+i+"b");
                objectIDs.push("object_"+i+"c");
            }
            const markerID= "locate_"+i.toString();
            const latitude = (minLat * multiplier + Math.round(Math.random() * (maxLat * multiplier - minLat * multiplier))) / multiplier;
            const longitude = (minLng * multiplier + Math.round(Math.random() * (maxLng * multiplier - minLng * multiplier))) / multiplier;
            /** @type {MLD._LngLat} */
            const lngLat = new maplibregl.LngLat(longitude, latitude);
            markersProps[markerID] = {
                lngLat: lngLat,
                centerOnClick: true,
                popupContent:
                    /**
                     *
                     * @param marker
                     * @returns {HTMLElement|string}
                     */
                        (marker) => {
                        return "I'm "+marker.markerID + (marker.getSelectedObjectID() ? " " + marker.getSelectedObjectID() : "")
                    },
                objectIDs: objectIDs.length ? objectIDs : undefined
            }
        }
        return markersProps;
    }


    /**
     *
     * @param _ {MouseEvent}
     */
    onReset(_){
        if(!this.primaryMarkerProps){
            this.primaryMarkerProps = this.createPrimaryMarkerProps();
        }
        this.map.applyPrimaryMarker(this.primaryMarkerProps);
    }


    /**
     *
     * @param _ {MouseEvent}
     */
    onTest(_){
        this.runNextMarkerTest();
        //this.runNewContentTest();
    }

    runNextMarkerTest(){
        if(!this.clusterMarkerProps){
            this.clusterMarkerProps = this.createClusterMarkerProps();
            const clusterProps = this.createClusterProps({
                markers: this.clusterMarkerProps,
            });
            this.map.applyCluster(clusterProps);
            return
        }
        const markers = this.clusterMarkerProps;
        /** @type {string|null} */
        let useTestMarkerID = null;
        /** @type {string|null} */
        let useTestObjectID = null;
        /** @type {(string|null)[][]} */
        let check = [];
        for(let markerID in markers){
            const marker = markers[markerID];
            const objectIDs = marker.objectIDs ?? [];
            if(objectIDs.length){
                for(let objectID of objectIDs){
                    check.push([markerID, objectID])
                }
            } else {
                check.push([markerID, null])
            }
        }
        for(let i = 0; i < check.length; i++){
            const item = check[i];
            if(i === 0){
                if(!this.testMarkerID && !this.testObjectID){
                    useTestMarkerID = item[0];
                    useTestObjectID = item[1];
                    break;
                }
            } else {
                const prevItem = check[i - 1];
                if((this.testMarkerID === prevItem[0]) && this.testObjectID === prevItem[1]){
                    useTestMarkerID = item[0];
                    useTestObjectID = item[1];
                    break;
                }
            }
        }
        if((useTestMarkerID !== this.testMarkerID) || (useTestObjectID !== this.testObjectID)){
            this.testMarkerID = useTestMarkerID;
            this.testObjectID = useTestObjectID;
            if(!useTestMarkerID){
                this.map.selectMarker(null)
            } else {
                this.map.selectClusterMarker(useTestMarkerID, useTestObjectID, true, true)
            }
        }
    }

    runNewContentTest(){

        /** @type {MLD._LngLat} */
        const lngLat = new maplibregl.LngLat(0, 0);
        this.primaryMarkerProps = this.createPrimaryMarkerProps({
            popupContent: "abc",
            lngLat: lngLat
        });
        this.map.applyPrimaryMarker(this.primaryMarkerProps);
        this.userMarkerProps = this.createUserMarkerProps({
            popupContent: "def"
        });
        this.map.applyUserMarker(this.userMarkerProps, true);

        this.clusterMarkerProps = this.createClusterMarkerProps();
        const clusterProps = this.createClusterProps({
            markers: this.clusterMarkerProps,
        });
        this.map.applyCluster(clusterProps);
    }
}

$(document).ready(() =>
{
    const mapLibreTests = document.querySelectorAll('#mapLibreTest');
    for(let mapLibreTest of mapLibreTests){
        new OSM.OSMTest(mapLibreTest);
    }
});